import { Injectable, Inject, Input, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http'
import {Platform} from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common'
import { ActivatedRoute } from '@angular/router'
import { Observable, BehaviorSubject } from 'rxjs'
// import { VCard } from "ngx-vcard";
// import { DeviceInfo } from 'ngx-device-detector';
import { IBrandcard, IBrandcardResult } from '../'
import { environment } from '@src/environments/environment'

export interface IShowModal {
  display: boolean
  which_text: '' | 'card_not_found' | 'private' | 'postcard' | 'zbuzz'
}

export interface IMediaBackground {
  isPlay: boolean
  isMute: boolean
  triggerFrom: string
}

@Injectable({
  providedIn: 'root',
})

export class CardPreviewService {
  id = 'a597e50502f5ff68e3e25b9114205d4a'
//   @Input() device: DeviceInfo

  private setTotalHeightCardFrame$ = new BehaviorSubject(0);
  currentTotalHeightCardFrame = this.setTotalHeightCardFrame$.asObservable();

  private setTotalHeightHeeaderImage$ = new BehaviorSubject({header_wrap: 0, image_wrap: 0});
  currentTotalHeightHeeaderImage = this.setTotalHeightHeeaderImage$.asObservable();

  private setStatusDisplayAllIcons$ = new BehaviorSubject(false);
  currentStatusDisplayAllIcons = this.setStatusDisplayAllIcons$.asObservable();

  private setProfileLogoToBottom$ = new BehaviorSubject(false);
  currentProfileLogoToBottom = this.setProfileLogoToBottom$.asObservable();

  private setProfileLogoToTop$ = new BehaviorSubject(false);
  currentProfileLogoToTop = this.setProfileLogoToTop$.asObservable();

  private setFooterToVisible$ = new BehaviorSubject(false);
  currentFooterToVisible = this.setFooterToVisible$.asObservable();

  private setShowModal$ = new BehaviorSubject({display: false, which_text: ''});
  currentShowModal = this.setShowModal$.asObservable();

  private setShowModalCardInfo$ = new BehaviorSubject(false);
  currentShowModalCardInfo = this.setShowModalCardInfo$.asObservable();

  private setShowAllActions$ = new BehaviorSubject(false);
  currentShowAllActions = this.setShowAllActions$.asObservable();

  private setScreen2$ = new BehaviorSubject(false);
  currentScreen2 = this.setScreen2$.asObservable();

  private setShowMessageIcons$ = new BehaviorSubject(false);
  currentShowMessageIcons = this.setShowMessageIcons$.asObservable();

  private setShowSocialLinkIcons$ = new BehaviorSubject(false);
  currentShowSocialLinkIcons = this.setShowSocialLinkIcons$.asObservable();

  private setenableDisableBackgroundSound$ = new BehaviorSubject<IMediaBackground>({isPlay: true, isMute: true, triggerFrom: 'default'});
  currentenableDisableBackgroundSound = this.setenableDisableBackgroundSound$.asObservable();

  constructor(
    private http: HttpClient,
    private platform: Platform,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private _doc: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  getWindow(): Window | null {
    return this._doc.defaultView;
  }
  
  getElementById(tag: string): any {
    return this._doc.getElementById(tag);
  }

  getWeblinkBrandcard(brandcard_id: string): Observable<IBrandcard> {
    return //this.http.get<IBrandcard>(`${environment.weblinkUrl}/v3/weblink/${brandcard_id}`)
  }

  setTotalHeightHeeaderImage(event: {header_wrap: number, image_wrap: number}) {
    this.setTotalHeightHeeaderImage$.next(event)
  }

  setTotalHeightCardFrame(event: number) {
    this.setTotalHeightCardFrame$.next(event)
  }

  setStatusDisplayAllIcons(event: boolean) {
    this.setStatusDisplayAllIcons$.next(event)
  }

  setProfileLogoToTop(event: boolean) {
    this.setProfileLogoToTop$.next(event)
  }

  setProfileLogoToBottom(event: boolean) {
    this.setProfileLogoToBottom$.next(event)
  }

  setFooterToVisible(event: boolean) {
    this.setFooterToVisible$.next(event)
  }

  setShowModal(event: IShowModal) {
    this.setShowModal$.next(event)
  }

  setShowModalCardInfo(event: boolean) {
    this.setShowModalCardInfo$.next(event)
  }

  setShowAllActions(event: boolean) {
    this.setShowAllActions$.next(event)
  }

  setScreen2(event: boolean) {
    this.setScreen2$.next(event)
  }

  setShowMessageIcons(event: boolean) {
    this.setShowMessageIcons$.next(event)
  } 

  setShowSocialLinkIcons(event: boolean) {
    this.setShowSocialLinkIcons$.next(event)
  } 

  setEnableDisableBackground(event: IMediaBackground) {
    this.setenableDisableBackgroundSound$.next(event)
  }

  lightOrDark(color) {
      // Variables for red, green, blue values
      var r, g, b, hsp;
      
      // Check the format of the color, HEX or RGB?
      if (color.match(/^rgb/)) {

          // If RGB --> store the red, green, blue values in separate variables
          color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
          
          r = color[1];
          g = color[2];
          b = color[3];
      } 
      else {
          
          // If hex --> Convert it to RGB: http://gist.github.com/983661
          color = +("0x" + color.slice(1).replace( 
          color.length < 5 && /./g, '$&$&'));

          r = color >> 16;
          g = color >> 8 & 255;
          b = color & 255;
      }
      
      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      hsp = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
      );

      const luminance = 0.299 * (r / 255) + 0.587 * (g / 255) + 0.114 * (b / 255);

      if (luminance > 0.5) {
        return 'light';
      }
      return 'dark';

      // Using the HSP value, determine whether the color is light or dark
      if (hsp>127.5) {

          return 'light';
      } 
      else {

          return 'dark';
      }
  }

  getPlatform() {
    return this.platform
  }

  // this function cant be used as is cant rename the label
  getVcard(mediaLinkData: IBrandcardResult, card_id: number) {
    // const vCard: VCard = {
    //   name: {
    //     firstNames: mediaLinkData.profiles.user_profile.name,
    //     lastNames: "",
    //   },
    //   telephone: [mediaLinkData.co_phone],
    //   email: [mediaLinkData.profiles.user_profile.email],
    //   workEmail: [mediaLinkData.co_email],
    //   title: mediaLinkData.co_regname,
    //   url: {
    //     home: mediaLinkData.info_links?.www,
    //     work: `${environment.card_url}${card_id}`
    //   },
    //   note: mediaLinkData.description,
    //   photo: mediaLinkData.icon,
    //   logo: mediaLinkData.icon,
    //   language: mediaLinkData.profiles.user_profile?.languages
    // }
    const vCard = {}

    return vCard
  }

  // this function get from the previous weblink codeds
  generateVCard(card: IBrandcardResult, card_id: number) {
    let vcardStr = '', info='';

    let str_vcard = 'BEGIN:VCARD\nVERSION:3.0', str_end = '\nEND:VCARD';

    /*TEL;TYPE=WORK,VOICE:(111) 555-1212
    TEL;TYPE=HOME,VOICE:(404) 555-1212
    ADR;TYPE=WORK,PREF:;;100 Waters Edge;Baytown;LA;30314;United States of America
    LABEL;TYPE=WORK,PREF:100 Waters Edge\nBaytown\, LA 30314\nUnited States of America
    ADR;TYPE=HOME:;;42 Plantation St.;Baytown;LA;30314;United States of America
    LABEL;TYPE=HOME:42 Plantation St.\nBaytown\, LA 30314\nUnited States of America
    EMAIL:forrestgump@example.com
    REV:2008-04-24T19:52:43Z*/

    var arr = [ "jpeg", "jpg", "gif", "png" ];


    if (card) {
        let mm = '',cname='', org="",addr="",label="",icon="",url="",note="",url1="";

        let iconurl = card.icon;

        if (iconurl!="") {
          if (iconurl.match(/\.(png)$/i)==null) {
            icon = '\nPHOTO;VALUE=URI;TYPE=JPEG:'+iconurl;
          }
          else {
            icon = '\nPHOTO;VALUE=URI;TYPE=PNG:'+iconurl;
          }
        }


        //let tel = '\nTEL;TYPE=HOME,VOICE:+' +  card.mobile +
          //'\nTEL;TYPE=WORK,VOICE:+' + card.mobile;
        
        const getNumber = card.mobile ? card.mobile : card.co_phone

        let tel = '\nTEL;TYPE=CELL,VOICE:+' +  getNumber;
        
         
        if (card.type == 'BC' || card.type == 'SC') {
            org = '\nORG:' + card.co_name;

            var adds = card.co_address.replace(/,/g,";");
            var label1 = card.co_address.replace(/,/g,",\n").replace(/;/g,",");
            

            addr='\nADR;TYPE=WORK,PREF:;;' + adds;
            label = '\nLABEL;TYPE=WORK,PREF:'+label1;

            let compicon = card.co_icon;
            let complogo = card.co_logo;

            if (compicon!="") {

              if (compicon.match(/\.(png)$/i)!=null) {
                icon = '\nPHOTO;VALUE=URI;TYPE=PNG:'+compicon;
              }
              else {
                icon = '\nPHOTO;VALUE=URI;TYPE=JPEG:'+compicon;
              }
            }

            tel = '\nTEL;TYPE=CELL,VOICE:+' + card.co_phone + '\nTEL;TYPE=WORK,VOICE:+' + card.co_phone;

            if (card.co_fax !='' && card.co_fax != null) {
              tel += '\nTEL;TYPE=WORK,FAX:' + card.co_fax;
            }

            note = '\nROLE:' + card.co_desc;
        }
        
        note = '\nNOTE:' + card.description;
        

        //let name = card.name.split(" ");
        //name = name.reverse();
      

        cname = '\nN:' + card.name + ';;' +
             '\nFN:'+card.name;

            //  var burl = `${environment.card_url}${card_id}`;
            var burl = ``;
             //url1 = '\nitem1.URL;type=pref:'+burl + '\nitem1.X-ABLabel:BRANDCARD';

         mm = cname + /*icon +*/ org + /*addr +*/ label + note;
       
         //let celltel = '\nTEL;TYPE=HOME,CELL:+' + card.mobile;
         const getemail = card.email ? card.email : card.co_email

          let email = '\nEMAIL:' + getemail;

          
          var dateobj = new Date(); 
          var isodate = dateobj.toISOString(); 

          var date = '\nREV:' + isodate;

                  
          if (typeof(card.social_links) != 'undefined' && card.social_links != null && typeof(card.social_links['www']) != 'undefined' && card.social_links['www']!='') {
             url = '\nURL:'+card.social_links['www'];
          }

          var url2 = '\nURL;type=brandcard:' + burl;

          info = mm + tel  + email + url + url2 +  date;
    }

    vcardStr = str_vcard + info + str_end;

    // if (this.device && this.device.os === 'iOS') {
    //   this.downloadVCardforchromeIOS(vcardStr, card.name)
    // } else {
    //   this.downloadVCard(vcardStr, card.name)
    // }

  }

  downloadVCard(text:string,name:string) {
    if (isPlatformBrowser(this.platformId)) {
      let filename = "";
  
      if (name != '') {
        filename = name + "-vcard.vcf";
      }
  
      var element = this._doc.createElement('a');
      element.setAttribute('href', 'data:text/vcard;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
  
      element.style.display = 'none';
      this._doc.body.appendChild(element);
  
      element.click();
  
      this._doc.body.removeChild(element);
    }
 }


  downloadVCardforchromeIOS(text:string,name:string) {
    if (isPlatformBrowser(this.platformId)) {
      let filename = "";
    
      if (name != '') {
        filename = name + "-vcard.vcf";
      }
    
      filename = filename.replace(/\s/g,'_');
    
      var element = this._doc.createElement('a');
      var blob = new Blob([text], {
        type: 'text/vcard;charset=utf-8'
      });
      element.setAttribute('href', 'data:text/vcard;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
    
      element.style.display = 'none';
      this._doc.body.appendChild(element);
    
      element.click();
      
      this._doc.body.removeChild(element);
    }
  }

}